export const BREAK_GLASS_CODE = '5008';

const BREAK_GLASS_WEBHOOK_URL =
  'https://webhook.site/aa469ce9-cfaf-4108-a537-333284d1f702';

export const getLoggedInUserDetails = (userData) => ({
  id: userData?._id || '',
  firstName: userData?.firstName || '',
  lastName: userData?.lastName || '',
  fullName:
    [userData?.firstName, userData?.lastName].filter(Boolean).join(' ') ||
    userData?.name ||
    '',
  email: userData?.email || '',
  username: userData?.username || '',
  role: userData?.roles?.name || userData?.role || '',
});

export const sendBreakGlassLog = (payload, page) => {
  const body = JSON.stringify({
    ...payload,
    page,
    occurredAt: new Date().toISOString(),
  });

  if (navigator.sendBeacon) {
    navigator.sendBeacon(
      BREAK_GLASS_WEBHOOK_URL,
      new Blob([body], { type: 'text/plain;charset=UTF-8' })
    );
    return;
  }

  fetch(BREAK_GLASS_WEBHOOK_URL, {
    method: 'POST',
    mode: 'no-cors',
    keepalive: true,
    headers: {
      'Content-Type': 'text/plain;charset=UTF-8',
    },
    body,
  }).catch(() => null);
};
